<script lang="ts">
	import data from './artists.json';
	import ArtistGroup from './ArtistGroup.svelte';
</script>

<main>
	<ArtistGroup artists={data.artists} startAt={1} />
</main>

<style>
	main {
		width: 80%;
		text-align: left;
		margin-left: auto;
		margin-right: auto;
	}
</style>
